import apiEndpoints from 'constants/apiEndpoints';
import { useEffect, useState } from 'react';
import fetchData from 'services/fetchData';

const getData = async url => {
  const response = await fetchData(url);
  if (response.status) {
    return response.data;
  }
  return [];
};

const useManageLocation = (resetStateCity = true) => {
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const fetchLocation = async (type, id, reset = true) => {
    if (type === 'country') {
      let countryData = await getData(apiEndpoints.location.getCounty);
      setCountry(countryData);
      if (reset) {
        setState([]);
        setCity([]);
      }
    } else if (type === 'state') {
      let stateData = await getData(apiEndpoints.location.getState(id));
      setState(stateData);
      setCity([]);
    } else if (type === 'city') {
      let cityData = await getData(apiEndpoints.location.getCity(id));
      setCity(cityData);
    }
  };

  useEffect(() => {
    fetchLocation('country', '', resetStateCity);
  }, []);

  const getDefaultLocation = async (
    { country_id, state_id },
    setModalLoading = () => {}
  ) => {
    setModalLoading(true, 'Fetching');
    if (country_id) {
      await fetchLocation('state', country_id);
    }
    if (state_id) {
      await fetchLocation('city', state_id);
    }
    setModalLoading(false);
  };

  const manageLocation = (
    formik,
    name,
    value,
    keys = { country: 'country_id', state: 'state_id', city: 'city_id' }
  ) => {
    if (name === keys.country) {
      fetchLocation('state', value);
      formik.setFieldValue(keys.state, '');
      formik.setFieldValue(keys.city, '');
    } else if (name === keys.state) {
      fetchLocation('city', value);
      formik.setFieldValue(keys.city, '');
    }
    formik.setFieldValue(name, value);
  };

  return { country, state, city, manageLocation, getDefaultLocation };
};

export default useManageLocation;
